<template>
  <div v-if="loading">
    <Spin
      :pointNum="8"
      :translateX="25"
      background="var(--base-primary-bgColor)" />
  </div>
  <div
    v-else
    class="card-list-box">
    <div
      v-if="!emptyFlag"
      class="list-content-box">
      <div class="common-checkbox-box">
        <el-checkbox
          class="checkbox-primary"
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange">
          全选
        </el-checkbox>
      </div>
      <div
        class="list-box"
        v-infinite-scroll="handleScroll"
        :infinite-scroll-distance="20">
        <div
          v-for="(item, index) in dataList"
          :key="index"
          class="list-item-box"
          :class="`${isElemChecked(item) ? 'activeList' : ''}`">
          <div
            class="img-box"
            :ref="`img-${item.id}`">
            <div
              class="mask-box"
              v-if="isExceptionStatus(item)">
              <div
                v-if="isQueuing(item)"
                class="icon-box">
                <icon-svg
                  size="40"
                  icon-class="ic-paiduizhong"
                  class="queue-icon" />
                <div class="description">排队中</div>
              </div>
              <ConvertLoading
                v-if="item.status === 2"
                :percentage="item.rate ? item.rate : 0"
                :message="item.rateMsg ? item.rateMsg : ''" />
              <div
                class="icon-box"
                v-if="item.status === 4">
                <icon-svg
                  size="40"
                  icon-class="ic-ico_instructions"
                  class="fail-icon" />
                <div class="description">转换失败</div>
              </div>
            </div>
            <img
              :src="getImgSrc(item)"
              @error="showImg" />
            <div
              class="opera-icon-box"
              @click.self="viewElem(item)">
              <div class="top-opera">
                <div
                  v-if="!isConverting(item)"
                  :class="getItemCheckBoxClassName(item)">
                  <el-checkbox
                    class="checkbox-primary"
                    :value="isElemChecked(item)"
                    @change="checked => handleCheckChange(item, checked)" />
                </div>
                <div
                  class="operation-button-box"
                  v-if="!isConverting(item)">
                  <div>
                    <div
                      class="icon-btn-box"
                      title="下载"
                      @click.stop="downloadElement(item)">
                      <icon-svg
                        size="16"
                        icon-class="ic-xiazai1"
                        class="icon" />
                    </div>
                  </div>
                  <div
                    class="common-dropdown-box"
                    v-if="isDropDownVisible()"
                    @mouseleave="changeStatus(item, false)">
                    <el-dropdown
                      :append-to-body="false"
                      placement="bottom-start"
                      @command="command => moreOperate(command, item)">
                      <div
                        class="icon-btn-box"
                        title="更多"
                        @click="changeStatus(item, true)">
                        <icon-svg
                          size="16"
                          icon-class="ic-gengduo"
                          class="icon" />
                      </div>
                      <el-dropdown-menu
                        slot="dropdown"
                        class="common-dropdown-menu dropdown-primary">
                        <div @mouseleave="changeStatus(item, false)">
                          <el-dropdown-item
                            command="1"
                            v-if="
                              isChecked(
                                'Project.ComponentLibrary.Private.Delete'
                              )
                            "
                            >删除</el-dropdown-item
                          >
                          <el-dropdown-item
                            command="2"
                            v-if="
                              isChecked('Project.ComponentLibrary.Private.Move')
                            ">
                            移动到
                          </el-dropdown-item>
                          <el-dropdown-item
                            command="3"
                            v-if="
                              item.status !== 4 &&
                              isChecked(
                                'Project.ComponentLibrary.Private.ChangeThumbnail'
                              )
                            ">
                            更换缩略图
                          </el-dropdown-item>
                        </div>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
              <div
                class="time-box public-tips-primary"
                v-if="!isExceptionStatus(item)">
                {{
                  item.uploadTime
                    ? formatTime(item.uploadTime)
                    : formatTime(item.creationTime)
                }}
              </div>
            </div>
          </div>
          <div :class="getElemInfoClassName(item)">
            <div class="top-box">
              <p
                class="name-box text-overflow"
                :title="formatName(item.name)">
                {{ formatName(item.name) }}
              </p>
            </div>
            <div class="bottom-box">
              <div class="tag-box">
                {{ formatFileType(item) }}
              </div>
              <div class="tag-box">
                {{
                  `${formatFileSize(item.length).fileSize}${
                    formatFileSize(item.length).unit
                  }`
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Empty
      v-else
      :uploadFile="uploadFile" />
  </div>
</template>

<script>
import Spin from '@/components/Spin.vue'
import Empty from '../components/Empty.vue'
import ConvertLoading from '../components/ConvertLoading.vue'

import { Store } from '@/utils/store'
import { formatTime, formatFileSize, getTokenId } from '@/utils/generalMethods'

import {
  privateElemListService,
  privateElemDeleteService,
  privateElemBatchDeleteService,
  getElemsConvertingProgress,
  getElemConvertStatus
} from '@/service/interface'

export default {
  data() {
    return {
      loading: true,
      imageBaseUrl: window.imageBaseUrl,
      isIndeterminate: false,
      checkAll: false,
      emptyFlag: false,
      currentPage: 1,
      pageSize: 100,
      dataList: [],
      selectedElements: [],
      convertingElems: []
    }
  },
  props: {
    initCatalog: Function,
    currNode: Object,
    elemUploader: Object,
    filterUser: String,
    sortValue: String,
    keywords: String,
    openMoveDialog: Function,
    openThumbnailDialog: Function
  },
  components: { Spin, Empty, ConvertLoading },
  created() {
    if (Object.keys(this.currNode).length) {
      this.initDataList()
    }
  },
  beforeDestroy() {},
  methods: {
    initDataList() {
      this.loading = true
      this.currentPage = 1
      this.queryElementList().then(response => {
        let { dataList, total } = response
        this.dataList = dataList

        this.emptyFlag = total ? false : true
        this.selectedElements = []
        this.checkAll = false

        this.loading = false

        this.$nextTick(() => {
          // 空态页上传按钮
          let emptyUploadDom = document.getElementById('empty-element-upload')
          if (emptyUploadDom) {
            let child = emptyUploadDom.children[0]
            if (!child.className.includes('webuploader-pick')) {
              this.elemUploader.uploader.addButton({
                id: '#empty-element-upload'
              })
            }
          }
        })

        this.queryConvertProgress(dataList)
      })
    },
    viewElem(elemInfo) {
      if (!this.isChecked('Project.ComponentLibrary.Private.ModelView')) return

      let dataSetId = elemInfo.dataSetId
      const routerUrl = this.$router.resolve({
        path: `./elementView`,
        query: { elemType: 'PrivateElem', dataSetId, elemName: elemInfo.name }
      })

      window.open(routerUrl.href, '_blank')
    },
    handleCheckChange(data, checked) {
      let findIndex = this.selectedElements.findIndex(el => el.id === data.id)
      if (checked && findIndex === -1) {
        this.selectedElements.push(data)
      }
      if (!checked && findIndex !== -1) {
        this.selectedElements.splice(findIndex, 1)
      }

      let checkedCount = this.selectedElements.length
      let total = this.dataList.length
      this.checkAll = checkedCount === total
      this.isIndeterminate = checkedCount > 0 && checkedCount < total
    },
    handleCheckAllChange(checked) {
      const exceptionValue = [1, 2] // 排队中、转换中构件状态值
      if (checked) {
        let dataList = this.dataList.map(item => item)
        let flag = dataList.every(el => exceptionValue.includes(el.status))
        if (flag) {
          this.isIndeterminate = false
          this.checkAll = false
          this.$message.warning('当前目录构件均在转换中，请稍后再试')
          return
        } else {
          this.selectedElements = dataList.filter(
            el => !exceptionValue.includes(el.status)
          )
        }
      } else {
        this.selectedElements = []
      }

      let checkedCount = this.selectedElements.length
      let total = this.dataList.length
      this.checkAll = checkedCount === total
      this.isIndeterminate = checkedCount > 0 && checkedCount < total
    },
    isElemChecked(data) {
      let find = this.selectedElements.find(el => el.id === data.id)
      if (find) {
        return true
      } else {
        return false
      }
    },
    changeStatus(data, visible) {
      let dom = this.$refs[`img-${data.id}`][0]
      if (visible) {
        dom.classList.add('active')
      } else {
        dom.classList.remove('active')
      }
    },
    uploadFile() {
      this.elemUploader.setStatus('waiting')
    },
    downloadElement(elemInfo, e) {
      e && e.stopPropagation()
      let files = [elemInfo]
      this.downloadFiles(files)
    },
    batchDownloadElem() {
      let elements = this.selectedElements
      if (!elements.length) {
        this.$message.warning('请勾选需要下载的构件')
        return
      }

      this.downloadFiles(elements)
    },
    downloadFiles(files) {
      this.$message({
        message: '开始下载文件，请勿重复操作......',
        type: 'info',
        duration: 3 * 1000
      })

      files.forEach((item, index) => {
        let url = ''
        let tokenId = getTokenId()
        if (window.downloadUrl.includes('http')) {
          url = `${window.downloadUrl}/${item.fileDataId}?token=${tokenId}`
        } else {
          url = `${window.serverUrl}/${window.downloadUrl}/${item.fileDataId}?token=${tokenId}`
        }

        this.downloadURL(url, index + 1)
      })
    },
    downloadURL(url, id) {
      let hiddenIFrameID = 'hiddenDownloader' + id
      let iframe = document.createElement('iframe')
      iframe.id = hiddenIFrameID
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
      iframe.src = url
    },
    moreOperate(command, elemInfo) {
      switch (command) {
        case '1':
          this.deleteElement(elemInfo)
          break
        case '2':
          this.openMoveDialog([elemInfo])
          break
        case '3':
          this.openThumbnailDialog(elemInfo)
          break
      }

      let dom = this.$refs[`img-${elemInfo.id}`][0]
      dom.classList.remove('active')
    },
    deleteElement(elemInfo) {
      this.$confirm('删除后需要重新上传并转换，是否继续', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let fileId = elemInfo.id
          privateElemDeleteService(fileId).then(response => {
            if (response.isSuccess) {
              this.initCatalog().then(() => {
                this.initDataList()
                this.$message.success('删除成功')
              })
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    batchDeleteElement() {
      let elements = this.selectedElements
      if (!elements.length) {
        this.$message.warning('请先选择构件')
        return
      }

      this.$confirm('删除后需要重新上传并转换，是否继续', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let fileIds = elements.map(el => el.id)
          privateElemBatchDeleteService({ fileIds }).then(response => {
            if (response.isSuccess) {
              this.initCatalog().then(() => {
                this.initDataList()
                this.$message.success('删除成功')
              })
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    batchMoveNode() {
      let elements = this.selectedElements
      if (!elements.length) {
        this.$message.warning('请先勾选文件')
        return
      }

      this.openMoveDialog(elements)
    },
    handleScroll() {
      if (this.allDataLoaded) return
      if (this.dataList.length < this.pageSize) return
      this.currentPage++
      this.queryElementList().then(response => {
        let { dataList } = response
        if (dataList.length) {
          this.dataList = [...this.dataList, ...dataList]
        } else {
          this.allDataLoaded = true
        }

        this.queryConvertProgress(dataList)
      })
    },
    queryElementList() {
      return new Promise(resolve => {
        let userInfo = Store.userInfo
        let userId = this.filterUser ? this.filterUser : userInfo.userId
        let params = {
          userId,
          parentId: this.currNode.nodeId,
          sortType: this.sortValue,
          name: this.keywords,
          resultCount: this.pageSize,
          skipCount: (this.currentPage - 1) * this.pageSize
        }
        privateElemListService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let dataList = data.items
            let total = data.totalCount
            dataList.forEach(item => {
              // 如果构件未转换成功，缩略图置空以解决转换成功后缩略图不更新的问题
              if (item.status !== 5) {
                item.thumbnail = ''
              }
            })
            resolve({ dataList, total })
          }
        })
      })
    },
    queryConvertProgress(dataList) {
      const statusArray = [1, 2]
      this.progressTimer && clearInterval(this.progressTimer)

      const convertingElems = dataList.filter(el =>
        statusArray.includes(el.status)
      )
      if (convertingElems.length) {
        this.updateConvertProgress(convertingElems)
        this.progressTimer = setInterval(() => {
          this.updateConvertProgress(convertingElems)
        }, 5000)
      }
    },
    refreshElemList() {
      this.currentPage = 1
      this.queryElementList().then(response => {
        let { dataList } = response
        this.dataList = dataList

        this.queryConvertProgress(dataList)
      })
    },

    updateConvertProgress(convertingElems) {
      let dataSetIds = convertingElems.map(el => el.dataSetId)
      getElemsConvertingProgress({ dataSetIds }).then(response => {
        if (response.isSuccess) {
          let dataList = response.data
          for (let i = 0; i < dataList.length; i++) {
            let item = dataList[i]

            let ratio = Math.round(item.ratio / 100) / 100
            let find = this.dataList.find(el => el.dataSetId === item.dataSetId)

            // 用于处理转换服务停止之后再重启的情况
            let findElem = this.convertingElems.find(
              el => el.dataSetId === item.dataSetId
            )
            if (findElem && findElem.isMarked && ratio === 0) {
              this.convertingElems = []
              this.refreshElemList()
              break
            }

            if (ratio !== 0 && find.status !== 2) {
              this.refreshElemList()
              break
            }
            if (ratio === 100) {
              getElemConvertStatus({ dataSetId: item.dataSetId }).then(res => {
                if (res.isSuccess) {
                  let result = res.data
                  let status = result.status
                  if (status === 10 || status === 20) {
                    this.refreshElemList()
                  } else {
                    this.$set(find, 'rate', 99)
                  }
                }
              })
              break
            } else {
              this.$set(find, 'rate', ratio)
              this.$set(find, 'rateMsg', item.message)
              if (ratio > 0) {
                if (!findElem) {
                  this.convertingElems.push({
                    dataSetId: item.dataSetId,
                    isMarked: true
                  })
                }
              }
            }
          }
        }
      })
    },
    showImg(img) {
      img.target.src = require('@/assets/img/no-thumbnail.png')
    },
    isConverting(elemInfo) {
      const convertingValue = [0, 1, 2] // 新创建、排队中、转换中的状态值
      return convertingValue.includes(elemInfo.status)
    },
    isExceptionStatus(elemInfo) {
      const exceptionValue = [0, 1, 2, 4] // 新创建、排队中、转换中、转换失败的构件状态值
      let status = elemInfo.status
      return exceptionValue.includes(status)
    },
    isQueuing(elemInfo) {
      const queuingValue = [0, 1] // 新创建、排队中均视为排队中(因为新创建的持续时间特别短)
      let status = elemInfo.status
      return queuingValue.includes(status)
    },
    getItemCheckBoxClassName(elemInfo) {
      let className = 'common-checkbox-box'
      if (this.isElemChecked(elemInfo)) {
        className += ' active'
      }
      return className
    },
    getElemInfoClassName(elemInfo) {
      let className = 'element-info-box'
      if (this.isExceptionStatus(elemInfo)) {
        className += ' disabled'
      }
      return className
    },
    formatName(name) {
      if (name.includes('obj.zip')) {
        return name.substring(0, name.lastIndexOf('.obj.zip'))
      } else {
        return name.substring(0, name.lastIndexOf('.'))
      }
    },
    formatFileType(fileInfo) {
      let name = fileInfo.name
      if (name.includes('obj.zip')) {
        return 'obj'
      } else {
        return fileInfo.fileType
      }
    },
    getImgSrc(imgInfo) {
      if (!imgInfo.thumbnail) {
        return require('@/assets/img/no-thumbnail.png')
      }

      // prettier-ignore
      const url = `${this.imageBaseUrl}/${imgInfo.thumbnail}?token=${getTokenId()}`
      let timestamp = new Date().getTime()
      let src = `${url}&timestamp=${timestamp}`
      return src
    },
    isDropDownVisible() {
      const permissionCodes = [
        'Project.ComponentLibrary.Private.Delete',
        'Project.ComponentLibrary.Private.Move',
        'Project.ComponentLibrary.Private.ChangeThumbnail'
      ]

      return permissionCodes.some(permissionCode =>
        this.isChecked(permissionCode)
      )
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    formatTime,
    formatFileSize,
    getTokenId
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.card-list-box {
  display: flex;
  flex-direction: column;
  height: 100%;
  text-align: left;

  .list-content-box {
    height: 100%;
    .list-box {
      display: flex;
      height: calc(100% - 51px);
      margin-top: 10px;
      flex-wrap: wrap;
      align-content: flex-start;
      overflow-y: auto;

      .list-item-box {
        width: calc((100% - 66px) / 6);
        margin-right: 12px;
        margin-bottom: 16px;
        padding: 16px;
        border-radius: 16px;
        background: var(--privateElement-page-list-bgColor);
        cursor: pointer;
        border: 1px solid var(--privateElement-page-list-border-color);

        &:nth-child(6n) {
          margin-right: 0;
        }
        .img-box {
          position: relative;
          height: 128px;
          border: 1px solid var(--element-page-list-card-img-border-color);
          border-radius: 6px;
          position: relative;
          // padding: 8px;

          &:hover {
            .time-box,
            .operation-button-box,
            .common-checkbox-box,
            .opera-icon-box {
              display: block !important;
            }
          }

          &:has(.active) {
            .opera-icon-box {
              display: block;
              .time-box,
              .common-checkbox-box {
                display: block !important;
              }
            }
          }

          .mask-box {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: var(--panel-loading-bg-color);
            text-align: center;
            z-index: 2;
            border-radius: 6px;

            :deep(.spinnner-item-box) {
              width: 12px;
              height: 12px;
              top: -13px;
            }

            :deep(.common-global-progress-box) {
              top: 80px;
              width: 60%;
              margin-left: 56px;
            }

            .icon-box {
              height: 40px;
              margin: 25% 40%;

              .queue-icon {
                color: var(--primary-color);
              }

              .fail-icon {
                color: var(--base-bg-light-color74);
              }

              .description {
                margin-top: 8px;
                font-size: 12px;
                font-weight: 400;
                white-space: nowrap;
                color: var(--aside-bg-color);
              }
            }
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
          }

          .common-checkbox-box {
            margin-top: -5px;
            display: none;
          }

          .operation-button-box {
            display: none;
            margin-top: -2px;

            & > div {
              display: inline-block;
            }

            .icon {
              margin-left: 10px;
              color: var(--base-primary-bgColor);
              font-size: 18px;
              line-height: 26px;
            }

            .common-dropdown-box {
              margin-top: -3px;
              .el-dropdown-menu {
                width: 120px;
              }
            }
          }
        }

        .element-info-box {
          margin-top: 12px;

          &.disabled {
            .top-box {
              opacity: 0.6;

              .icon-box {
                cursor: not-allowed;

                .icon {
                  pointer-events: none;
                }
              }
            }

            .bottom-box {
              opacity: 0.6;
            }
          }
          .top-box {
            overflow: hidden;

            .name-box {
              color: var(--privateElement-page-list-text-color);
              font-size: 12px;
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .icon-box {
              .icon {
                font-size: 16px;
              }

              .is-collected {
                color: var(--base-light-color10);
              }
            }
          }

          .common-button-box {
            display: flex;
            justify-content: flex-start;
            margin-top: 4px;

            .small-size {
              padding: 0 8px;
              height: 20px;
              font-size: 12px;
              &:last-child {
                margin-left: 8px;
              }
            }
          }

          .bottom-box {
            display: flex;
            justify-content: flex-start;
            margin-top: 4px;
            font-size: 12px;

            .tag-box {
              display: flex;
              align-items: center;
              margin-right: 8px;
              margin-bottom: 2px;
              padding: 0px 4px;
              background: var(--base-bg-light-color73);
              border: 1px solid var(--base-bg-light-color55);
              border-radius: 4px;
              color: var(--base-bg-light-color55);
            }
          }
        }
      }

      .activeList {
        &:not(:has(.disabled)) {
          border: 1px solid var(--base-primary-bgColor);
        }
      }

      .opera-icon-box {
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: var(--base-bg-dark-color7);
        padding: 8px;
        top: 0;
        left: 0;
        display: none;
        border-radius: 4px;
        z-index: 3;

        .top-opera {
          display: flex;
          justify-content: space-between;

          .operation-button-box {
            display: none;
            margin-right: 2px;

            & > div {
              display: inline-block;

              .icon-btn-box {
                display: flex;
                margin-left: 4px;
                width: 26px;
                height: 26px;
                padding: 4px;
                border-radius: 5px;
                text-align: center;
                background: var(--element-card-list-icon-bgColor);

                &:hover {
                  background: var(--element-card-list-icon-hover-bgColor);
                }

                .icon {
                  margin: auto;
                  color: var(--element-card-list-icon-color);
                  font-size: 18px;
                }
              }
            }

            .common-dropdown-box {
              margin-top: -3px;
              .el-dropdown-menu {
                width: 120px;
              }
            }
          }

          .common-checkbox-box {
            margin-top: -7px;
            margin-left: 2px;
            display: none;
          }
        }

        .time-box {
          position: absolute;
          bottom: 8px;
          display: none;
          width: 100%;
          color: var(--aside-bg-color);
        }
      }
    }

    .common-empty-box {
      .upload-btn {
        padding: 0px 30px;
      }
    }
  }
}
</style>
